import { useState } from "react";
import { Button, Menu, MenuItem, Checkbox, ListItemText, List, ListItemButton } from "@mui/material";
import { useTranslation } from "react-i18next";

interface Props {
    tenantData: any;
    selectedTenants: string[];
    onSave: (Tenants: string[]) => void;
}

const TenantDropdown = (props: Props) => {
    const [t] = useTranslation();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [selectedTenants, setSelectedTenants] = useState<string[]>(props.selectedTenants.map((tenant: any) => tenant.id));

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setSelectedTenants(props.selectedTenants.map((tenant: any) => tenant.id));
        setAnchorEl(event.currentTarget);
    };

    const handleSave = () => {
        props.onSave(props.tenantData.filter((tenant: any) => selectedTenants.includes(tenant.id)));
        handleClose();
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleToggle = (tenantId: string) => () => {
        const currentIndex = selectedTenants.indexOf(tenantId);
        const newSelectedTenants = [...selectedTenants];

        if (currentIndex === -1) {
            newSelectedTenants.push(tenantId);
        } else {
            newSelectedTenants.splice(currentIndex, 1);
        }

        setSelectedTenants(newSelectedTenants);
    };

    const open = Boolean(anchorEl);

    return (
        <div style={{ marginRight: "16px" }}>
            <Button
                color="success"
                variant="text"
                onClick={handleClick}
                endIcon={open ? <span className="material-icons">keyboard_arrow_down</span> : <span className="material-icons">keyboard_arrow_up</span>}
                style={{ color: "#333", textTransform: "none" }}
            >
                {t("userSystem.tenantName")}
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <div className="p-2">
                    <List>
                        {props.tenantData.map((tenant: any) => (
                            <ListItemButton
                                key={tenant.id}
                                dense
                                onClick={handleToggle(tenant.id)}
								selected={selectedTenants.indexOf(tenant.id) !== -1}
								color="success"
                            >
                                <Checkbox
                                    size="small"
                                    edge="start"
                                    color="success"
                                    checked={selectedTenants.indexOf(tenant.id) !== -1}
                                    disableRipple
                                />
                                <ListItemText primary={tenant.tenantName} />
                            </ListItemButton>
                        ))}
                    </List>
                    <div style={{ marginTop: "8px", display: "flex", justifyContent: "space-between" }}>
                        <Button
                            color="success"
                            disabled={selectedTenants.length === 0}
                            onClick={() => setSelectedTenants([])}
                        >
                            {t("buttons.reset")}
                        </Button>
                        <div>
                            <Button
                                color="success"
                                onClick={handleClose}
                            >
                                {t("buttons.close")}
                            </Button>
                            <Button
                                variant="contained"
                                color="success"
                                onClick={handleSave}
                            >
                                {t("buttons.save")}
                            </Button>
                        </div>
                    </div>
                </div>
            </Menu>
        </div>
    );
};

export default TenantDropdown;
